import React, {Suspense} from 'react';
import {Preloader} from '@ab/components';

const Main = React.lazy(() => import(/* webpackChunkName: "Cart" */ './views/main.c'));

const Subscriptions = props => {
    return (
        <Suspense fallback={<Preloader className="center" />}>
            <Main {...props} />
        </Suspense>
    );
};

export default Subscriptions;
